import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';
import { authGuard } from './app/core/guards/auth.guard';
import { debugModeGuard } from './app/core/guards/debug-mode.guard';
import { superAdminGuard } from './app/core/guards/super-admin.gaurd';
import { publicGuard } from './app/core/guards/public.guard';
import { DashboardComponent } from './app/pages/dashboard/dashboard/dashboard.component';
import { manualPatientFeedbackGuard } from './app/core/guards/manual-patient-feedback.guard';
import { programGuard } from './app/core/guards/program.guard';
import { supportTicketGuard } from './app/core/guards/support-ticket.guard';
import { careServiceGuard } from './app/core/guards/care-service.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      { path: '', canActivate: [authGuard], component: DashboardComponent },
      {
        path: 'appointments',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/appointments/appointments.routes').then((r) => r.appointmentsRoutes)
      },
      {
        path: 'appointment-visits',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./app/pages/appointment-visit/appointment-visits.routes').then((r) => r.appointmentVisitRoutes)
      },
      { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') },
      {
        path: 'caregiver',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/caregiver/caregiver.routes').then((r) => r.caregiverRoutes)
      },
      {
        path: 'care-service',
        canActivate: [authGuard, careServiceGuard],
        loadChildren: () => import('./app/pages/care-service/care-service.routes').then((r) => r.careServiceRoutes)
      },
      {
        path: 'company',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/company/company.routes').then((m) => m.companyRoutes)
      },
      {
        path: 'data-exchange',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/data-exchange/data-exchange.routes').then((r) => r.dataExchangeRoutes)
      },
      {
        path: 'finance',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/finance/finance.routes').then((r) => r.FINANCE_ROUTES)
      },
      {
        path: 'hha-config',
        canActivate: [authGuard, superAdminGuard],
        loadChildren: () => import('./app/pages/hha-config/hha-config.routes').then((r) => r.hhaConfigRoutes)
      },
      {
        path: 'insurance',
        canActivate: [authGuard, superAdminGuard],
        loadChildren: () => import('./app/pages/insurance/insurance.routes').then((r) => r.insuranceRoutes)
      },
      {
        path: 'invoice',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/invoice/invoice.routes').then((r) => r.insuranceRoutes)
      },
      {
        path: 'patient',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/patient/patient.routes').then((r) => r.patientRoutes)
      },
      {
        path: 'profile',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/profile/profile.routes').then((r) => r.profileRoutes)
      },
      {
        path: 'settings',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/settings/settings.routes').then((r) => r.settingsRoutes)
      },
      {
        path: 'payment-methods',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./app/pages/payment-methods/payment-methods.routes').then((r) => r.paymentMethodRoutes)
      },
      {
        path: 'bills-and-payments',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./app/pages/bills-and-payments/bills-and-payments.routes').then((r) => r.billsAndPaymentsRoutes)
      },
      {
        path: 'imports',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/imports/import.routes').then((r) => r.importRoutes)
      },
      {
        path: 'task',
        canActivate: [authGuard],
        loadChildren: () => import('./app/pages/task/task.routes').then((r) => r.taskRoutes)
      },
      {
        path: 'user',
        canActivate: [authGuard, superAdminGuard],
        loadChildren: () => import('./app/pages/user/user.routes').then((r) => r.userRoutes)
      },
      {
        path: 'advance-billing-invoice',
        canActivate: [authGuard, superAdminGuard],
        loadChildren: () =>
          import('./app/pages/advance-billing-invoice/advance-billing-invoice.routes').then(
            (r) => r.advanceBillingInvoiceRoutes
          )
      },
      {
        path: 'report',
        canActivate: [authGuard, manualPatientFeedbackGuard],
        loadChildren: () => import('./app/pages/report/report.routes').then((r) => r.reportRoutes)
      },
      {
        path: 'program',
        canActivate: [authGuard, programGuard],
        loadChildren: () => import('./app/pages/program/program.routes').then((r) => r.programRoutes)
      },
      {
        path: 'support-ticket',
        canActivate: [authGuard, supportTicketGuard],
        loadChildren: () =>
          import('./app/pages/support-ticket/support-ticket.routes').then((r) => r.supportTicketRoutes)
      },
      {
        path: 'migration',
        canActivate: [authGuard, superAdminGuard, debugModeGuard],
        loadChildren: () => import('./app/pages/migration/migration.routes').then((r) => r.migrationRoutes)
      },
      {
        path: 'dev-only',
        canActivate: [authGuard, superAdminGuard, debugModeGuard],
        loadChildren: () => import('./app/pages/dev-only/dev-only.routes').then((r) => r.devOnlyRoutes)
      }
    ]
  },
  {
    path: 'public',
    children: [
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('./app/pages/privacy-policy/privacy-policy.routes').then((r) => r.privacyPolicyRoutes)
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () =>
          import('./app/pages/terms-and-conditions/terms-and-conditions.routes').then((r) => r.termsAndConditionsRoutes)
      }
    ]
  },
  { path: 'notfound', component: Notfound },
  {
    path: 'auth',
    canActivate: [publicGuard],
    loadChildren: () => import('./app/pages/auth/auth.routes')
  },
  { path: '**', redirectTo: '/notfound' }
];
